import { getIsRecipient, has_permission } from 'config/permissions';
import { useAppSelector } from 'helpers/hooks';
import { RecipientsDashboard } from './Recipients/RecipientsDashboard';
import { getActiveRole } from 'selectors/admins';
import DonationsDashboard from './DonationsDashboard';

const Dashboard = () => {
  const activeRole = useAppSelector(getActiveRole);

  if (!activeRole) return null;

  if (!has_permission('DASHBOARD_ROUTE', 'R', activeRole)) {
    return (
      <div className="content">
        <h1 className="title-permission">
          Sorry, you don&apos;t have permission to see this screen.
        </h1>
      </div>
    );
  }

  if (getIsRecipient(activeRole)) {
    return <RecipientsDashboard />;
  }

  return <DonationsDashboard />;
};

export default Dashboard;
